module.exports = __webpack_public_path__ + "img/gap_logo.c0a6a28e.png";